import type { ProductType } from '@shared/products-types';
import { createRegistry } from '@luna/utils';

type ExternalProductFetcher = (
    id: string,
    productType: ProductType | undefined,
) => Promise<unknown> | undefined;

/** Registry for external products to reload their data when the accountBalanceService runs (e.g. after a new payment).
 * The registry will be called by the accountBalanceService */
export const externalProductBalanceRefreshRegistry = createRegistry<ExternalProductFetcher>();
